import { useEffect } from "react";
import {
    applyHistoricalDataPatch,
    getQbdJsonHistoricalDataDefaultsPatch,
    SyncToggleFields,
} from "./syncTogglePatches";

interface UseQbdJsonHistoricalDataDefaultsParams {
    isQbdJsonMigration: boolean;
    historicalData: SyncToggleFields;
    setFieldValue: (field: string, value: boolean) => void;
}

export function useQbdJsonHistoricalDataDefaults({
    isQbdJsonMigration,
    historicalData,
    setFieldValue,
}: UseQbdJsonHistoricalDataDefaultsParams): void {
    useEffect(() => {
        if (!isQbdJsonMigration) {
            return;
        }
        const patch = getQbdJsonHistoricalDataDefaultsPatch(historicalData);
        if (!patch) {
            return;
        }
        applyHistoricalDataPatch({ patch, setFieldValue });
    }, [isQbdJsonMigration, historicalData, setFieldValue]);
}
